import compose from 'lodash/fp/compose';
import filterFp from 'lodash/fp/filter';
import mapFp from 'lodash/fp/map';
import map from 'lodash/map';
import uniq from 'lodash/uniq';
import PropTypes from 'prop-types';
import React, {memo, useCallback} from 'react';

import Item from './components/Item';
import WriteItem from './components/WriteItem';

const StringListField = ({value, onChange, disabled, rules}) => {

  const handleAdd = useCallback((newValue) => {
    compose(
      onChange,
      uniq,
    )([
      ...value,
      newValue
    ]);
  }, [onChange, value]);

  const handleEdit = useCallback((oldValue, newValue) => {
    compose(
      onChange,
      uniq,
      mapFp((_value) => _value === oldValue ? newValue : _value)
    )(value);
  }, [onChange, value]);

  const handleRemove = useCallback((oldValue) => {
    compose(
      onChange,
      filterFp((_value) => _value !== oldValue)
    )(value);
  }, [onChange, value]);

  return (
    <div>
      {/*  add item */}
      <WriteItem onChange={handleAdd} rules={rules}/>

      {/*  list items */}
      {map(value, (v, i) => (
        <Item key={`${v}-${i}`} value={v} onChange={handleEdit} onRemove={handleRemove} disabled={disabled} rules={rules}/>
      ))}
    </div>
  );
};

StringListField.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  rules: PropTypes.array,
};

StringListField.defaultProps = {
  onChange: () => undefined,
  value: [],
  rules: [],
};

export default memo(StringListField);
